export default {
  path: '/reception-desk/:code',
  name: 'r_self-registration-reception-desk',
  meta: {},
  component: () =>
    import('../../components/self-registration-reception-desks/SelfRegistrationReceptionDesk.vue'),
};
